// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___2f5f-","header":"header___78g2-","tab":"tab___WR7ie","item":"item___1lCLP","activated":"activated___2Eq_p","body":"body___SWQCg"};